export default {
      id: "one-crore-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#one-crore",
      toString: function () {
        return this.url;
      }
    }